module.exports = __webpack_public_path__ + "static/media/29ADMSPC17.c3110c4e.jpg";